const state = {
  shippingMultichannelInfoItemNumber: 3,
  shippingMultichannelInfoItems: [],
  currentShippingMultichannelInfoSeq: null,
  shippingMultichannelInfoDefaultItem: null,
  selectedshippingMultichannelInfoItem: null
}

const getters = {
  getShippingMultichannelInfoItems: state => state.shippingMultichannelInfoItems,
  getShippingMultichannelInfoDefaultItem: state => state.shippingMultichannelInfoDefaultItem,
  getCurrentShippingMultichannelInfoSeq: state => state.currentShippingMultichannelInfoSeq,
  getShippingMultichannelInfoItemNumber: state => state.shippingMultichannelInfoItemNumber,
  getSelectedShippingMultichannelInfoItem: state => state.selectedshippingMultichannelInfoItem
}

const mutations = {
  setShippingMultichannelInfoItems (state, items) {
    state.shippingMultichannelInfoItems = items
    state.shippingMultichannelInfoDefaultItem = items.find(item => parseInt(item.defFlg)) || null
  },
  setCurrentShippingMultichannelInfoSeq (state, seq) {
    state.currentShippingMultichannelInfoSeq = seq
  },
  setShippingMultichannelInfoDefaultItem (state, item) {
    state.shippingMultichannelInfoDefaultItem = item
  },
  setSelectedShippingMultichannelInfoItem (state, item) {
    state.selectedshippingMultichannelInfoItem = item
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shippingmultichannelinfo.js